module.exports = __webpack_public_path__ + "img/img6.1e7e13e2.jpg";